// extracted by mini-css-extract-plugin
export default {"facetMenu":"Dw-z","fixed":"Ew-z","nonLayerdFacets":"Fw-z","productCount":"Gw-z","facetBack":"Hw-z","arrow":"Iw-z","facetClose":"Jw-z"};